import { createFileRoute } from '@tanstack/react-router';

import Step3Success from 'component/view/Onboarding/Step3Success';

import { blockRegistrationInWpSiteControl } from './-guards';

export const Route = createFileRoute('/n/_auth/register/success')({
  beforeLoad: () => {
    blockRegistrationInWpSiteControl();
  },
  component: Step3Success,
});
